export const environment = {
  version: require("../../package.json").version,
  production: false,
  staging: true,
  development: false,

  apiUrl: "https://apiadmintest2.soliportal.com/api/v1",
  notificationsUrl: "",
  serverStellar: "",
  cognito:
    "https://solimarket.auth.us-east-2.amazoncognito.com/login?client_id=5fea3mc2khcr8vtletukq00ukv&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://admintest2.soliportal.com/auth/login",

  cognitoUrl: "https://solimarket.auth.us-east-2.amazoncognito.com/",
  cognitoClientId: "5fea3mc2khcr8vtletukq00ukv",
  cognitoClientSecret: "",

  cognitoRedirectUrl: "https://admintest2.soliportal.com/auth/login",
  cognitoScope: "aws.cognito.signin.user.admin+email+openid+phone+profile",
  cognitoResponseType: "code",
};
